import React, { useState } from "react";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import Logo from "../assets/ekologo.png";
import { useNavigate } from "react-router-dom";
import { axiosAuth } from "../api/axios";
import { setCredentials } from "../redux/authSlice";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { TextField, Button, Box, Typography } from "@mui/material";

const MainWrapper = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: #90ee90;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
`;

const ErrorText = styled.p`
  color: red;
`

const LoginCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const LoginPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [errorlogin, setErrorLogin] = useState('')
  const [showPassword, setShowPassword] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    //console.log(data)
    try {
      const response = await axiosAuth.post("/auth/login", {
        email: data.email,
        pwd: data.password,
      });

      const userData = response.data;

      dispatch(setCredentials(userData));
      if (userData?.user?.role === "Admin") {
        navigate(`/${userData.user.organization}/users`);
      }
      if (userData?.user?.role === "SuperAdmin") {
        navigate("/admintable");
      }
      if (userData?.user?.role === "User") {
        navigate(`/patients`);
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setErrorLogin("Username or password is incorrect.");
      } else {
        setErrorLogin("An unexpected error occurred. Please try again.");
      }
    }
  };
  const currentYear = new Date().getFullYear();
  return (
    <>
      <MainWrapper />
      <Box>
      <LoginCenter>
      <form onSubmit={handleSubmit(onSubmit)} style={{ width: '500px', padding: '20px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)', borderRadius: '8px', backgroundColor: '#fff' }}>
        <img src={Logo} alt='logo' style={{ maxWidth: "100%", height: "auto", marginBottom: '30px' }}/>
        <TextField
        label="Email"
        fullWidth
        {...register("email", {
          required: 'Email is required',
          pattern: {
            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
            message: 'Invalid email format'
          }
        })}
        error={!!errors.email}
        helperText={errors.email?.message}
        style={{ marginBottom: "20px" }}
      />
      <TextField
              label="Password"
              type={showPassword ? "text" : "password"} // Toggle visibility of password
              fullWidth
              {...register("password", { required: "Password is required" })}
              error={!!errors.password}
              helperText={errors.password?.message}
              style={{ marginBottom: "10px" }}
              InputProps={{
                endAdornment: showPassword ? (
                  <VisibilityOff
                    onClick={() => setShowPassword(false)}
                    style={{ cursor: "pointer" }}
                  />
                ) : (
                  <Visibility
                    onClick={() => setShowPassword(true)}
                    style={{ cursor: "pointer" }}
                  />
                ),
              }}
            />
           <ErrorText>{errorlogin}</ErrorText>
      <Button type="submit" variant="contained" color="primary" fullWidth 
      style={{ marginTop: "20px", height: "50px", fontSize: "1.2rem", backgroundColor: "#046840" }}>
        Log In
      </Button>
      <Typography variant="body2" align="center" style={{ marginTop: "10px", color: "#555" }}>
        Copyright © Ekovel Centar {currentYear}
      </Typography>
    </form>
    
    </LoginCenter>
    </Box>
      
    </>
  );
};

export default LoginPage;
